import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Space from "@/pages/Space";
import Availability from "@/pages/Availability";
import Inquire from "@/pages/Inquire";
import Faq from "@/pages/Faq";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import AuthCallback from "@/pages/admin/AuthCallback";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/space" element={<Space />} />
      <Route path="/availability" element={<Availability />} />
      <Route path="/inquire" element={<Inquire />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.15, smoothWheel: true });
    return () => lenis.destroy();
  }, []);
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <div className="App">
            <AppRouter />
          </div>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
